// extracted by mini-css-extract-plugin
module.exports = {"container":"route_container__x2C-B"};